import Form from '../../app-components/form/Form';
import {submitByQuery} from '../../AppServices';
import {PLACEHOLDER} from '../../app-components/utils';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';

export default ({uri, header}) => {
  const MedicalHistoryForm = Form({
    type: 'standardShadow',
    onSubmit: submitByQuery({
      query_id: 'addMedicalHistory',
    }),
    uri,
    closeView: 1,
    reloadEvent: 'reloadMedicalHistory',
    mandatory: {name_en: 1},
    lg: {
      header,
      formGroups: [
        {
          columnsPerRow: 1,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name_en',
                  mandatory: true,
                  placeholder: PLACEHOLDER,
                  label: 'Medical History Name',
                  width: '50%',
                },
              ],
            },
          ],
        },
      ],
    },
    sm: {
      header: {
        title: header.title,
      },
      footer: {
        actions: [cancelButton(), save()],
      },
      formGroups: [
        {
          columnsPerRow: 1,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  mandatory: true,
                  placeholder: PLACEHOLDER,
                  label: 'Medical Histories Name',
                },
              ],
            },
          ],
        },
      ],
    },
  });
  return MedicalHistoryForm;
};
